<template>
  <el-card>
    <el-form ref="searchInfo" :model="info" class="global-form" :inline="true">
      <el-form-item>
        <el-input v-model="info.templateName" placeholder="请输入模板名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="mb20">
      <el-button type="primary" icon="el-icon-plus" @click="onAdd">新增</el-button>
    </div>
    <el-table ref="table" class="global-table" stripe v-loading="loading" :data="tableData" max-height="550px">
      <el-table-column label="模板名称" min-width="80px" show-overflow-tooltip prop="templateName">
      </el-table-column>
      <el-table-column label="使用项目" min-width="80px" show-overflow-tooltip prop="projectNames">
      </el-table-column>
      <el-table-column label="状态" min-width="60px" show-overflow-tooltip>
        <template v-slot="{ row }">
          <el-switch disabled :active-value="0" :inactive-value="1" v-model="row.isDisable" active-color="#7973ef"
                     inactive-color="#333333">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onExamine(row.templateId, row.isDisable)">{{ row.isDisable === 0 ? '禁用' :
            '启用'}}</el-button>
          <el-button type="text" @click="onEdit(row.templateId)">编辑</el-button>
          <el-button type="text" @click='onDelete(row.templateId)'>删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Add :addShow.sync="addShow" @success="loadData" :id.sync=id></Add>
    <global-pagination :total="total" :current-page.sync="page" :page-size.sync="size" @current-change="loadData"
                       @size-change="loadData"></global-pagination>
  </el-card>
</template>

<script>
import Add from './DailyTemplateListAdd.vue'

export default {
  name: 'maintenanceDay',
  components: { Add },
  data () {
    return {
      info: {
        templateName: '',
        projectIds: [],
        optionList: []
      },

      addShow: false,
      id: '', // 编辑的时候可以使用

      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: []

    }
  },
  computed: {
    projectList () {
      return this.$store.state.projectList
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    onSearch () {
      this.page = 1
      this.loadData()
    },

    loadData () {
      this.loading = true
      this.$axios
        .get(
          this.$apis.maintenanceDaily.selectYhDailyTemplateByPage,
          {
            ...this.info,
            page: this.page,
            size: this.size
          }
        )
        .then((res) => {
          if (res) {
            this.total = res.total || 0
            this.tableData = res.list || []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 新增
    onAdd () {
      // console.log('新增')
      // this.$router.push({ name: 'addTeams' })

      this.id = 'add'
      this.addShow = true
    },

    // 编辑
    onEdit (id) {
      this.id = id
      this.addShow = true
    },

    // 修改状态
    onExamine (templateId, status) {
      const tips = status === 0 ? '禁用' : '启用'
      this.$confirm(`确认${tips}吗, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.maintenanceDaily.disableYhDailyTemplate, { templateId }).then(() => {
          this.$message.success('操作成功')
          this.loadData()
        })
      })
    },

    // 删除
    onDelete (templateId) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$axios.post(this.$apis.maintenanceDaily.deleteYhDailyTemplate, { templateId }).then(() => {
            this.$message.success('删除成功')
            this.onSearch()
          }).finally(() => {
            this.loading = false
          })
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped lang="scss">

::v-deep .el-table__body-wrapper {
  overflow-y: hidden;
}

.button-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
</style>
